<template>
  <div class="d-flex justify-space-between" style="width: 100%">
    <div class="linea-pedido">
      <LineaNoSePuede v-if="!fromWaiters" v-model="imposible" :item="item" :order-id="idPedido" />
      <div class="linea-pedido__devuelta" v-if="devuelta">
        <v-icon x-small color="deep-orange darken-3">mdi-alert-circle-outline</v-icon> La caja pide cambiar este producto
      </div>
      <div class="linea-pedido__devuelta" v-if="item.status === 'unavailable'">
        <v-icon x-small color="deep-orange darken-3">mdi-cancel</v-icon> No se puede: {{ razonImposible || "sin motivo" }}. Quítalo y agrega otro.
      </div>
      <div class="linea-pedido__titulo">
        <span class="linea-pedido__nombre">{{ item.product.name }}</span>
        <span class="linea-pedido__total">{{ $filters.currency(item.total_amount, 0) }}</span>
      </div>
      <div class="linea-pedido__marcas" v-if="item.product.product_type === 'gift'">
        <v-chip x-small label color="amber lighten-4" title="Al cobrar se crea una tarjeta pendiente: hay que activarla en «Tarjetas Compradas»">
          <v-icon x-small left color="amber darken-3">mdi-gift-outline</v-icon>Tarjeta regalo
        </v-chip>
      </div>
      <div class="linea-pedido__marcas" v-if="!fromWaiters && $store.getters.isDrugStore && item.product.info_medication">
        <v-chip x-small label color="orange lighten-4" v-if="item.product.info_medication.requires_formula"
          :title="$t('description_prescription')">
          <v-icon x-small left color="orange darken-2">mdi-prescription</v-icon>Requiere fórmula
        </v-chip>
        <v-chip x-small label color="red lighten-4" v-if="item.product.info_medication.controlled_product"
          :title="$t('description_mce')">
          <v-icon x-small left color="red" :class="{ blinking: isBlinking }">mdi-account-lock</v-icon>Controlado
        </v-chip>
      </div>
      <div class="linea-pedido__medico" v-if="medico" @click="$emit('prescription:item', item)" title="Ver o cambiar el médico">
        <v-icon small color="green darken-1">mdi-stethoscope</v-icon>
        <span class="linea-pedido__medico-texto"><strong>{{ medico.nombre }}</strong> · RM {{ medico.tarjeta }}</span>
        <v-icon x-small color="grey darken-1">mdi-pencil-outline</v-icon>
      </div>
      <div class="linea-pedido__medico linea-pedido__medico--falta" :class="{ 'linea-pedido__medico--obligatorio': medicoObligatorio }"
        v-else-if="pideMedico" @click="$emit('prescription:item', item)">
        <v-icon small>{{ medicoObligatorio ? "mdi-alert-outline" : "mdi-stethoscope" }}</v-icon>
        <span class="linea-pedido__medico-texto">{{ medicoObligatorio ? "Falta el médico (obligatorio para cobrar)" : "Agregar el médico de la fórmula" }}</span>
        <v-icon x-small>mdi-chevron-right</v-icon>
      </div>
      <div class="linea-pedido__detalle" v-if="item.product_variant">{{ item.product_variant.name }}</div>
      <div class="linea-pedido__detalle" v-for="(d, i) in detalleWaiters" :key="'d' + i">
        <strong v-if="d.nombre">{{ d.nombre }}:</strong> {{ d.valor }}
      </div>
      <div class="linea-pedido__nota" v-if="item.note">
        <v-icon x-small color="amber darken-3">mdi-comment-text-outline</v-icon> {{ item.note }}
      </div>
      <div class="linea-pedido__pie">
        <div class="item-cantidad">
          <v-btn v-if="!item.product.is_scale" icon outlined small color="error" :disabled="bloqueada || item.quantity <= 1"
            aria-label="Quitar uno" @click="restar">
            <v-icon small>mdi-minus</v-icon>
          </v-btn>
          <span class="item-cantidad__numero">{{ item.quantity }}</span>
          <v-btn v-if="!item.product.is_scale" icon outlined small color="success" :disabled="bloqueada"
            aria-label="Agregar uno" @click="changeQuantity(item)">
            <v-icon small>mdi-plus</v-icon>
          </v-btn>
          <span class="item-cantidad__precio" v-if="!fromWaiters && item.product.unity">{{ item.product.unity.name }}</span>
          <span class="item-cantidad__precio" v-if="item.quantity != 1">× {{ $filters.currency(getPriceUnitaryItem(item), 0) }}</span>
          <v-chip color="red" dark x-small v-if="item.percentage_discount > 0" class="ml-1">
            - {{ item.percentage_discount }}%
          </v-chip>
        </div>
        <div class="item-acciones">
          <span class="item-enviada" v-if="bloqueada"><v-icon x-small>mdi-lock-outline</v-icon> Enviado</span>
          <span class="item-enviada" v-else-if="protegida" title="Ya se guardó o se imprimió: cambiarla o quitarla pide un motivo">
            <v-icon x-small>mdi-lock-outline</v-icon> Guardada
          </span>
          <v-btn icon v-if="puedeMarcarImposible" title="No se puede preparar" aria-label="No se puede preparar" @click="imposible = true">
            <v-icon small color="grey darken-1">mdi-cancel</v-icon>
          </v-btn>
          <v-btn icon v-if="!fromWaiters && $store.getters.isDrugStore && item.product.info_medication && item.product.info_medication.requires_formula"
            :title="$t('Agregar información de fórmula médica')" aria-label="Fórmula médica" @click="$emit('prescription:item', item)">
            <v-icon small color="orange darken-2">mdi-prescription</v-icon>
          </v-btn>
          <v-btn icon :disabled="bloqueada" :title="$t('edit')" aria-label="Editar"
            @click="editar">
            <v-icon small color="grey darken-1">mdi-pencil-outline</v-icon>
          </v-btn>
          <v-btn icon :disabled="bloqueada" :title="$t('delete')" aria-label="Quitar"
            @click="quitar">
            <v-icon small color="grey darken-1">mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <MotivoDeCambio :dialog="modalMotivo" :titulo="motivoTitulo" :detalle="item.product.name" @cancelar="modalMotivo = false" @confirmar="confirmarMotivo" />
  </div>
</template>

<script>
import LineaNoSePuede from "./LineaNoSePuede";
import MotivoDeCambio from "./MotivoDeCambio";
import { razonImposible as razonDeLinea } from "@/plugins/pedidos-rechazados";
export default {
  name: "CartSectionItem",
  components: { LineaNoSePuede, MotivoDeCambio },
  data() {
    return {
      imposible: false,
      showTooltip: false,
      modalMotivo: false,
      motivoTitulo: "",
      motivoPendiente: null,
    };
  },
  props: ["item", "fromWaiters"],
  mounted() {},
  computed: {
    idPedido() {
      const orden = this.$pos && this.$pos.getCurrentOrder && this.$pos.getCurrentOrder();
      return (orden && orden.id) || "";
    },
    // Una línea que ya se envió a cocina de un pedido guardado en el servidor, y que no se ha preparado ni marcado.
    puedeMarcarImposible() {
      const orden = this.$pos && this.$pos.getCurrentOrder && this.$pos.getCurrentOrder();
      // «No se puede» es del plan restaurante: solo ahí hay cocina y pedidos enviados a preparar.
      if (!this.$store.getters.isRestaurant) return false;
      if (!orden || !orden.id || this.fromWaiters) return false;
      if (!["pending", "received", "preparing", "returned"].includes(orden.order_status)) return false;
      return !!this.item.id && !["prepared", "unavailable"].includes(this.item.status);
    },
    // Una línea que el mesero ya envió queda fija desde ese momento (también si ya se imprimió): así no
    // se puede borrar lo que cocina ya preparó. Lo nuevo que se agregue al pedido sí se puede editar y
    // quitar; anular lo ya enviado lo hace la caja, con motivo y quién lo autorizó.
    // Solo mientras el pedido siga devuelto: al reenviarlo vuelve a «pending» y la marca deja de verse.
    devuelta() {
      const orden = this.$pos && this.$pos.getCurrentOrder && this.$pos.getCurrentOrder();
      return !!this.item.devuelta && !!orden && orden.order_status === "returned";
    },
    razonImposible() {
      const orden = this.$pos && this.$pos.getCurrentOrder && this.$pos.getCurrentOrder();
      const lineas = (orden && orden.data_items) || [];
      return orden ? razonDeLinea(orden, lineas.indexOf(this.item)) : "";
    },
    // En la caja, una línea que ya se guardó en el servidor o se imprimió (cuenta o comanda) no se cambia ni se
    // quita sin un motivo: así no se puede imprimir, cobrar y retirar productos sin que quede rastro.
    protegida() {
      if (this.fromWaiters || this.item.status === "unavailable") return false;
      return !!this.item.printed || !!this.item.save_from_seller;
    },
    bloqueada() {
      // En la caja nada queda fijo: quien cobra puede cambiar o quitar lo que sea.
      if (!this.fromWaiters) return false;
      // Lo que cocina marcó «No se puede» no se preparó: el mesero sí puede quitarlo.
      if (this.item.status === "unavailable") return false;
      return !!this.item.printed || !!this.item.save_from_seller;
    },
    // Las opciones elegidas de la línea, en texto simple: «Término: Medio», «Adicionales: Tocineta, Huevo».
    detalleWaiters() {
      const detalle = [];
      const opciones = this.item.options || {};
      for (const k of Object.keys(opciones)) {
        const o = opciones[k];
        if (!o || o.option_type !== "custom") continue;
        const valor = Array.isArray(o.value) ? o.value.join(", ") : o.value;
        if (valor) detalle.push({ nombre: o.name, valor });
      }
      for (const sub of this.item.sub_items || []) {
        detalle.push({ nombre: "", valor: sub.quantity + " × " + sub.product.name });
      }
      return detalle;
    },
    // El médico de la fórmula, ya registrado en la línea.
    medico() {
      const d = this.item.data_doctor;
      if (this.fromWaiters || !this.$store.getters.isDrugStore || !d || !d.professional_card) {
        return null;
      }
      return { nombre: [d.first_name || d.name, d.last_name].filter(Boolean).join(" "), tarjeta: d.professional_card };
    },
    pideMedico() {
      const im = this.item.product && this.item.product.info_medication;
      return !this.fromWaiters && this.$store.getters.isDrugStore && !!im && !!(im.requires_formula || im.controlled_product);
    },
    medicoObligatorio() {
      const im = this.item.product && this.item.product.info_medication;
      return !!(im && im.controlled_product);
    },
    isBlinking() {
      if (this.item.data_doctor && this.item.data_doctor.professional_card) {
        return false;
      }
      return true;
    },
  },
  methods: {
    restar() {
      this.conMotivo("reducida", "Quitar una unidad", () => this.changeQuantity(this.item, false));
    },
    editar() {
      this.conMotivo("editada", "Cambiar la línea", () => this.$emit("edit:item", this.item));
    },
    quitar() {
      this.conMotivo("quitada", "Quitar la línea", () => this.$emit("delete:item", this.item));
    },
    // Una línea protegida pide el motivo antes de actuar; el resto actúa directo.
    conMotivo(accion, titulo, hacer) {
      if (!this.protegida) {
        hacer();
        return;
      }
      this.motivoPendiente = { accion, hacer };
      this.motivoTitulo = titulo;
      this.modalMotivo = true;
    },
    confirmarMotivo(motivo) {
      const p = this.motivoPendiente;
      this.modalMotivo = false;
      if (!p) return;
      const orden = this.$pos.getCurrentOrder();
      const u = this.$store.getters.user;
      const usuario = u ? u.name : "";
      let rastro = orden.data_order_trace;
      if (typeof rastro === "string") {
        try {
          rastro = JSON.parse(rastro);
        } catch (e) {
          rastro = [];
        }
      }
      orden.data_order_trace = [
        ...(rastro || []),
        {
          tipo: "linea_" + p.accion,
          linea_id: this.item.id,
          motivo,
          usuario,
          fecha: this.$filters.datetime(new Date()),
          producto: this.item.product.name,
          cantidad: this.item.quantity,
          total: this.item.total_amount,
        },
      ];
      if (p.accion === "quitada") {
        this.item.deletion_reason = motivo;
        this.item.deleted_by = usuario;
      }
      this.motivoPendiente = null;
      p.hacer();
    },
    getPriceUnitaryItem(item) {
      return item.unit_price;
    },
    changeQuantity(item, sum = true) {
      let quantity = item.quantity;
      if (sum) {
        quantity++;
      } else if (!sum && quantity - 1 > 0) {
        quantity--;
      }
      this.updateItem(item, quantity);
    },
    updateItem(item, newQuantity) {
      let opts = {
        itemLine: item,
        variant: item.product_variant,
        quantity: newQuantity,
        note: item.note,
        options: item.options,
        discount: item.real_discount,
        new_price: item.unit_price,
        bill_price_list_id: item.price_list_id,
      };
      this.$emit("selectedOptions", opts);
    },
  },
};
</script>

<style>
/* Cantidad de la línea en la app de meseros: el número en grande entre – y +. */
.item-cantidad {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
}

.item-cantidad__numero {
  min-width: 24px;
  text-align: center;
  font-size: 1.2rem;
  font-weight: 800;
}

.linea-pedido {
  width: 100%;
  padding: 14px 0 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.linea-pedido__titulo {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.linea-pedido__nombre {
  flex: 1;
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.25;
}

.linea-pedido__total {
  flex: 0 0 auto;
  font-size: 1.05rem;
  font-weight: 800;
}

.linea-pedido__detalle {
  margin-top: 3px;
  padding-left: 10px;
  border-left: 3px solid rgba(94, 53, 177, 0.35);
  font-size: 0.9rem;
  line-height: 1.3;
  color: rgba(0, 0, 0, 0.7);
}

.linea-pedido__medico {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 4px 0;
  padding: 5px 10px;
  border: 1.5px solid #66bb6a;
  border-radius: 10px;
  background: #f1f8e9;
  font-size: 0.85rem;
  cursor: pointer;
}

.linea-pedido__medico-texto {
  flex: 1;
  min-width: 0;
}

.linea-pedido__medico--falta {
  border-color: rgba(0, 0, 0, 0.2);
  border-style: dashed;
  background: #fff;
  color: rgba(0, 0, 0, 0.65);
}

.linea-pedido__medico--obligatorio {
  border-color: #f57c00;
  background: #fff3e0;
  color: #e65100;
  font-weight: 600;
}

.linea-pedido__marcas {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.linea-pedido__devuelta {
  margin-bottom: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #bf360c;
}

.linea-pedido__nota {
  margin-top: 4px;
  font-size: 0.85rem;
  font-style: italic;
  color: rgba(0, 0, 0, 0.6);
}

.linea-pedido__pie {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

.item-enviada {
  align-self: center;
  margin-right: 4px;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.55);
}

.item-acciones {
  display: flex;
  justify-content: flex-end;
  gap: 2px;
  padding-right: 8px;
}

.item-cantidad__precio {
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.6);
}

/*
 * La línea de un sub-ítem (opción de venta) vive dentro de un `v-list-item-subtitle`, que en
 * Vuetify 2 es `white-space: nowrap; overflow: hidden`: en la columna angosta del carrito el
 * total se cortaba («+ $2,000» se veía «+ $2,00»). Cantidad × precio a la izquierda y el total
 * a la derecha, como la línea principal, y si no caben pasan a otro renglón en vez de cortarse.
 */
.cart-subitem-nombre {
  white-space: normal;
}
.cart-subitem-linea {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 0 0.5rem;
  white-space: normal;
}
.ssfix_tooltip {
  opacity: 1 !important;
}
.blinking {
  animation: blink 0.5s infinite alternate;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.3;
  }
}
</style>